import { render, staticRenderFns } from "./VisitorsContacts.vue?vue&type=template&id=43d56ec0&"
import script from "./VisitorsContacts.vue?vue&type=script&lang=js&"
export * from "./VisitorsContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports